import { render, staticRenderFns } from "./PedidosFiltrando.vue?vue&type=template&id=fed7fb22&scoped=true&"
import script from "./PedidosFiltrando.vue?vue&type=script&lang=js&"
export * from "./PedidosFiltrando.vue?vue&type=script&lang=js&"
import style0 from "./PedidosFiltrando.vue?vue&type=style&index=0&id=fed7fb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7fb22",
  null
  
)

export default component.exports